import TableList from "@components/templates/tablelist";
import compDetail from './detail';
import comProgram from './comprogram';
import { HttpTemplateList,HttpSaveProgram } from '@/service/boss/allot';
import { mapGetters } from "vuex";
export default {
    mixins: [TableList],
    components: {
        compDetail,
        comProgram
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            Plugins: { show: true },
            formData: {
                search: {
                    EQ_status: null
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100
            }
        };
    },
    methods: {
        ajaxRequest: HttpTemplateList,
        handleOperates(params = "", type, batch) {
            if (batch) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        id:params,
                        title: this.$t('global.common.query',{defaultValue:'查看'}),
                        component: 'compDetail',
                        show: true,
                        width: 720,
                    };
                    break;
                case 'add':
                    this.$router.push({
                        name: 'tempDetail',
                        params: { type: 'add' }
                    });
                    break;
                case 'edit':
                    this.$router.push({
                        name: 'tempDetail',
                        params: { type: 'edit' },
                        query: { id:params }
                    });
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS+"/api/v2/AmazonTemplate/export", {ids:params}, 'download')
                    break;
                case 'allexport':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS+"/api/v2/AmazonTemplate/exportByFilter", {search:{...this.formData.search}}, { executor: 'request', download: true })
                    break;
                case 'upload':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.b2c.import_data',{defaultValue:'导入数据'}),
                        width:460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/AmazonTemplate/import",
                        name: "excelFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/AmazonTemplate/excel',{},'download')
                        },
                    };
                    break;
                case 'program':
                    this.operate = {
                        id:params,
                        title: this.$t('erp.virtualstore.shiptemplateapplet',{defaultValue:'亚马逊发运模板生成小程序'}),
                        component: 'comProgram',
                        show: true,
                        width: 450,
                        showFooter:false,
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: this.$t('global.common.query',{defaultValue:'查看'}),
                    show: true,
                    params: id,
                    operate: "query"
                },
                {
                    label:this.$t('global.common.edit',{defaultValue:'编辑'}),
                    show: true,
                    params: id,
                    operate: "edit"
                }
            ];
        }
    },

    computed: {
        ...mapGetters('boss',['warehouses','accountFlag']),
        TabsData() {
            return [
                {
                    name: this.$t('fbb.alloment.all',{defaultValue:'所有'}),
                    key: "EQ_status",
                    val: null
                },
                {
                    name: this.$t('global.common.effective', { defaultValue: '有效' }),
                    key: "EQ_status",
                    val: "ACTIVE"
                },
                {
                    name: this.$t('fbb.accountmanage.loss_effect', { defaultValue: "失效" }),
                    key: "EQ_status",
                    val: "INACTIVE"
                }
            ];
        },
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add',{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.import',{defaultValue:'导入'}),
                    operate: "upload",
                    theme: "success",
                    more:true,
                },
                {
                    name: this.$t('global.common.export',{defaultValue:'导出'}),
                    operate: "export",
                    theme: "info",
                    more:true,
                    batch:true,
                },
                {
                    name: this.$t('erp.virtualstore.templateapplet',{defaultValue:'模板生成程序'}),
                    operate: "program",
                    theme: "success",
                    more:true,
                },
                {
                    name: this.$t('global.common.condition_export',{defaultValue:'查询条件导出'}),
                    operate: "allexport",
                    theme: "success",
                    more:true,
                },
            ];
        },
        SearchsData() {
            const accountFlag=this.accountFlag.map(function(item){
                const {flag,title}=item;
                return {
                    value:flag,
                    label:`${title}(${flag})`
                }
            }),
            warehouses=this.warehouses.map(function(item){
                return {
                    value:item.id,
                    label:item.code
                }
            });
            return [
                {
                    label: this.$t('fbb.accountmanage.template_name',{defaultValue:'模板名称'}),
                    tag: "vInput",
                    key: "CN_name",
                    show: true
                },
                {
                    label: this.$t('erp.virtualstore.description',{defaultValue:'模板描述'}),
                    tag: "vInput",
                    key: "CN_description",
                    show: true,
                },
                {
                    label: this.$t('erp.virtualstore.amazonaccount',{defaultValue:'亚马逊账号'}),
                    tag: "vSelect",
                    key: "CN_accountFlag",
                    show: true,
                    options: accountFlag,
                    props: {
                        filterable: true
                    }
                },
                {
                    label: this.$t('erp.virtualstore.safeQuantity',{defaultValue:'安全库存'}),
                    tag: "vInput",
                    key: "EQ_safetyStock",
                },
                {
                    label: this.$t('bi.work.task_priority',{defaultValue:'优先级'}),
                    tag: "vInput",
                    key: "EQ_priority",
                },
                {
                    label: this.$t('erp.virtualstore.correspwarehouse',{defaultValue:'对应仓库'}),
                    tag: "vSelect",
                    key: "IN_items.warehouseId",
                    options:warehouses,
                    // formatter(value){
                    //     return (value||[]).join(',')
                    // },
                    props: {
                        filterable: true,
                        multiple:true,
                    }
                }, {
                    label: this.$t('erp.virtualstore.amazonname',{defaultValue:'亚马逊模板名称'}),
                    tag: "vInput",
                    key: "EQ_code",
                },{
                    label: this.$t('erp.virtualstore.property',{defaultValue:'模板属性'}),
                    tag: "vSelect",
                    key: "EQ_property",
                    options:[{
                        value:'',
                        label:this.$t('global.common.all',{defaultValue:'全部'})
                    },{
                        value:'NORMAL',
                        label:this.$t('fbb.bill.account_common',{defaultValue:'正常'})
                    },{
                        value:'SFP',
                        label:'SFP'
                    }],
                }, {
                    label: "默认模板",
                    tag: "vSelect",
                    key: "EQ_isDefault",
                    options:[{
                        value:'',
                        label:this.$t('global.common.all',{defaultValue:'全部'})
                    },{
                        value:1,
                        label:this.$t('global.common.yes',{defaultValue:'是'})
                    },{
                        value:0,
                        label:this.$t('global.common.no',{defaultValue:'否'})
                    }],
                },
                {
                    label: this.$t('fbb.adjustment.created_name',{defaultValue:'创建人'}),
                    tag: "vInput",
                    key: "CN_createdName",
                },
            ];
        },
        columns() {
            return [
                {
                    type: "selection",
                    width: 40,
                    align: "center",
                    formName: "id"
                },
                {
                    title: this.$t('global.common.operate',{defaultValue:'操作'}),
                    width: 70,
                    render: this.getOperateNodes
                },
                {
                    title: '#ID',
                    width: 80,
                    key: 'id',
                    sortable: true,
                },
                {
                    title: this.$t('fbb.accountmanage.template_name',{defaultValue:'模板名称'}),
                    key: 'name',
                    sortable: true,
                    render: (h, { row }) => {
                        return <a onClick={this.handleOperates.bind(this, row.id,'query')}>{row.name}</a>
                    }
                },
                {
                    title: this.$t('erp.virtualstore.description',{defaultValue:'模板描述'}),
                    key: 'description',
                    sortable: true,
                    maxWidth: 200,
                },
                {
                    title: this.$t('erp.virtualstore.correspwarehouse',{defaultValue:'对应仓库'}),
                    key: 'items',
                    render(h, { row }) {
                        return (row.items||[]).map((item) => {
                            return <div>{item.warehouseCode}</div>
                        })
                    }
                },
                {
                    title: 	this.$t('fbb.expresspackage.baseinfo',{defaultValue:'基本信息'}),
                    maxWidth: 160,
                    render(h, { row }) {
                        return <div>
                            <div>{this.$t('erp.virtualstore.safeQuantity',{defaultValue:'安全库存'})}：{row.safetyStock}</div>
                            <div>{this.$t('bi.work.task_priority',{defaultValue:'优先级'})}：{row.priority}</div>
                            <div>{this.$t('erp.virtualstore.property',{defaultValue:'模板属性'})}：{row.property}</div>
                            <div>{this.$t('erp.virtualstore.isDefault',{defaultValue:'默认模板'})}：{row.isDefault == '0' ? this.$t('global.common.no',{defaultValue:'否'}) : this.$t('global.common.yes',{defaultValue:'是'})}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                    maxWidth: 180,
                    key: 'updatedAt',
                    sortable: true,
                },{
                    title: this.$t('erp.virtualstore.tempstatus',{defaultValue:'模板状态'}),
                    key: 'status',
                    sortable: true,
                    render: (h, { row }) => {
                        const {label,theme}=row.status==='ACTIVE'?{
                            label:this.$t('global.common.effective', { defaultValue: '有效' }),
                            theme:'success'
                        }:{
                            label:this.$t('fbb.accountmanage.loss_effect', { defaultValue: "失效" }),
                            theme:'error'
                        }
                        return <vButton ghost theme={theme} size="small" class="cursor-default width-60">{label}</vButton>
                    }
                }
            ];
        }
    }
};
